(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["oonote-review-client"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.OonoteReviews) return;
  const active = new WeakSet();
  const decodeText = value => String(value || '').replace(/&(#x[\da-f]+|#\d+|amp|lt|gt|quot|apos|nbsp);/gi, (match, entity) => {
    const named = { amp: '&', lt: '<', gt: '>', quot: '"', apos: "'", nbsp: '\u00a0' };
    if (entity[0] !== '#') return named[entity.toLowerCase()] || match;
    const code = entity[1].toLowerCase() === 'x' ? parseInt(entity.slice(2), 16) : parseInt(entity.slice(1), 10);
    return code > 0 && code <= 0x10ffff ? String.fromCodePoint(code) : match;
  });
  const parseReview = value => {
    const body = decodeText(value).replace(/\r\n?/g, '\n').trim();
    const match = /^Note OONOTE : ([1-5])\/5\n\n+([\s\S]+)$/.exec(body);
    const valid = match && match[2].trim();
    return { rating: valid ? Number(match[1]) : null, body: valid ? match[2].trim() : body };
  };
  function stars(element, rating, label) {
    element.textContent = '★★★★★';
    element.style.setProperty('--review-fill', `${rating / 5 * 100}%`);
    element.setAttribute('role', 'img');
    element.setAttribute('aria-label', label);
  }
  function card(review, root) {
    const parsed = parseReview(review.body);
    const item = document.createElement('article');
    item.className = 'review-card oonote-public-review';
    if (parsed.rating !== null) {
      const score = document.createElement('div');
      score.className = 'oonote-review-stars';
      stars(score, parsed.rating, root.dataset.reviewRatingLabel.replace('OONOTE_AVERAGE', String(parsed.rating)));
      item.append(score);
    }
    const body = document.createElement('blockquote');
    body.textContent = parsed.body;
    const author = document.createElement('div');
    author.className = 'review-author';
    author.textContent = decodeText(review.author);
    item.append(body, author);
    const date = new Date(review.date);
    if (Number.isFinite(date.getTime())) {
      const time = document.createElement('time');
      time.className = 'review-meta';
      time.dateTime = date.toISOString();
      time.textContent = date.toLocaleDateString(document.documentElement.lang || 'fr', { day: 'numeric', month: 'long', year: 'numeric' });
      item.append(time);
    }
    return item;
  }
  async function loadAll(endpoint) {
    const first = new URL(endpoint, location.origin);
    if (first.origin !== location.origin) throw new Error('Review origin');
    first.searchParams.set('view', 'oonote-review-data');
    first.searchParams.set('page', '1');
    let next = first;
    const seenPages = new Set();
    const reviews = new Map();
    let expectedTotal = null;
    while (next) {
      if (next.origin !== location.origin || next.pathname !== first.pathname || seenPages.has(next.href) || seenPages.size >= 500) throw new Error('Review pagination');
      seenPages.add(next.href);
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 12000);
      let response;
      try {
        response = await fetch(next.href, { credentials: 'same-origin', signal: controller.signal });
        if (!response.ok) throw new Error('Review response');
        const data = await response.json();
        if (!Array.isArray(data.reviews) || !('next' in data) || !Number.isSafeInteger(data.total) || data.total < 0) throw new Error('Review data');
        if (expectedTotal !== null && expectedTotal !== data.total) throw new Error('Review total changed');
        expectedTotal = data.total;
        for (const review of data.reviews) {
          if (!review || !['string', 'number'].includes(typeof review.id) || typeof review.body !== 'string' || typeof review.author !== 'string' || typeof review.date !== 'string') throw new Error('Review shape');
          reviews.set(String(review.id), review);
        }
        next = data.next ? new URL(data.next, first) : null;
        if (next) next.searchParams.set('view', 'oonote-review-data');
      } finally {
        clearTimeout(timeout);
      }
    }
    if (reviews.size !== expectedTotal) throw new Error('Incomplete review list');
    return Array.from(reviews.values());
  }
  async function init(root) {
    if (!root || active.has(root)) return;
    active.add(root);
    root.dataset.reviewState = 'loading';
    root.querySelectorAll('[data-review-unavailable]').forEach(item => { item.hidden = true; });
    try {
      const reviews = await loadAll(root.dataset.reviewEndpoint || root.dataset.reviewSource);
      const ratings = reviews.map(review => parseReview(review.body).rating).filter(rating => rating !== null);
      const count = 19 + ratings.length;
      const average = (95 + ratings.reduce((sum, rating) => sum + rating, 0)) / count;
      const formatted = average.toLocaleString(document.documentElement.lang || 'fr', { minimumFractionDigits: 1, maximumFractionDigits: 1 });
      root.querySelectorAll('[data-review-average]').forEach(item => { item.textContent = formatted; item.hidden = false; });
      root.querySelectorAll('[data-review-count]').forEach(item => { item.textContent = String(count); item.hidden = false; });
      root.querySelectorAll('[data-review-stars]').forEach(item => { stars(item, average, root.dataset.reviewRatingLabel.replace('OONOTE_AVERAGE', formatted)); item.hidden = false; });
      root.querySelectorAll('[data-review-metrics]').forEach(item => { item.hidden = false; });
      root.querySelectorAll('[data-new-reviews]').forEach(container => {
        const fragment = document.createDocumentFragment();
        reviews.slice().sort((a, b) => new Date(b.date) - new Date(a.date)).slice(0, 6).forEach(review => fragment.append(card(review, root)));
        container.replaceChildren(fragment);
        container.hidden = !reviews.length;
      });
      root.dataset.reviewState = 'ready';
    } catch (error) {
      console.warn('OONOTE reviews:', error.message);
      root.dataset.reviewState = 'unavailable';
      root.querySelectorAll('[data-review-average], [data-review-count], [data-review-stars], [data-review-metrics]').forEach(item => { item.hidden = true; });
      root.querySelectorAll('[data-review-unavailable]').forEach(item => { item.hidden = false; });
    }
  }
  window.OonoteReviews = { init, parseReview, loadAll };
  const start = () => document.querySelectorAll('[data-oonote-reviews]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

})();
